module.exports = __webpack_public_path__ + "media/images/spinner-1268827c3dc2c33a913db376aa6deec4.gif";